import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { store } from "./app/store";
import { Provider } from "react-redux";
import { ApolloProvider } from "@apollo/client";
import { apolloClient } from "./app/graphql";
import * as serviceWorker from "./serviceWorker";
import  './app/Room'
import styled from "styled-components";





ReactDOM.render(
  <React.StrictMode>
    <div id="voice"></div>
    <Provider store={store}>
      <ApolloProvider client={apolloClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ApolloProvider>
      {/* <ReactionContainer></ReactionContainer> */}
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);




// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
